import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { TermItem } from 'sections/Resources/FreightDictionary/types';
import { Term } from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList/Term';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/TermsList/TermsList.module.scss';

const cn = classNames.bind(styles);

type TermsList = {
  id: string;
  label: string;
  terms: Array<TermItem>;
}

const TermsList: FC<TermsList> = ({ id, label, terms }: TermsList): ReactElement => {
  const termsElements = terms.map((item: TermItem) => {
    return (
      <Term key={item.id} name={item.name} url={item.url} description={item.description}/>
    );
  });

  return (
    <li className={cn('terms')}>
        <h3 className={cn('terms__title')} id={id}>{label}</h3>
        <ul className={cn('terms__items')}>
          {termsElements}
        </ul>
    </li>
  );
};

export { TermsList };